import { FC, useEffect, useState } from "react";

import { DatePicker, Flex, Select } from "antd";
import fr from "antd/es/date-picker/locale/fr_FR";
import dayjs from "dayjs";

type AvailabilityMode = "none" | "immédiate" | "date";

const parseMode = (value: string | null | undefined): AvailabilityMode => {
  if (!value) return "none";
  if (value === "immédiate") return "immédiate";
  return "date";
};

interface AvailabilityPickerProps {
  value?: string | null;
  onChange?: (value: string | null) => void;
  style?: React.CSSProperties;
}

const AvailabilityPicker: FC<AvailabilityPickerProps> = ({
  value,
  onChange,
  style,
}) => {
  const [mode, setMode] = useState<AvailabilityMode>(() => parseMode(value));

  useEffect(() => {
    setMode(parseMode(value));
  }, [value]);

  const handleModeChange = (newMode: AvailabilityMode) => {
    setMode(newMode);
    if (newMode === "none") {
      onChange?.(null);
    } else if (newMode === "immédiate") {
      onChange?.("immédiate");
    }
  };

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    onChange?.(date ? date.format("YYYY-MM-DD") : null);
  };

  return (
    <Flex gap={8} style={style}>
      <Select
        value={mode}
        onChange={handleModeChange}
        style={{ width: mode === "date" ? 160 : "100%" }}
        options={[
          { value: "none", label: "Non définie" },
          { value: "immédiate", label: "Immédiate" },
          { value: "date", label: "Date définie" },
        ]}
      />
      {mode === "date" && (
        <DatePicker
          value={value && value !== "immédiate" ? dayjs(value) : null}
          onChange={handleDateChange}
          locale={fr}
          format="YYYY-MM-DD"
          style={{ flex: 1 }}
        />
      )}
    </Flex>
  );
};

export default AvailabilityPicker;

export const formatAvailability = (value: string | null | undefined): string => {
  if (!value) return "";
  if (value === "immédiate") return "Immédiate";
  try {
    return new Intl.DateTimeFormat("fr").format(new Date(value));
  } catch {
    return value;
  }
};
